export default "__VITE_ASSET__CnSttmeX__"